<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 17C5.10781 15.8922 6.03156 14.858 6.77124 13.8973M6.77124 13.8973C8.25698 11.9678 9 10.3352 9 9C9 6 8 6 7 6C6 6 4.968 7.085 5 9C5.02563 10.5437 5.95468 12.5312 6.77124 13.8973ZM6.77124 13.8973C7.03796 14.3436 7.29268 14.7235 7.5 15C9 17 10 17.5 11 16L13 13C13.333 15.667 14.333 17 16 17C16.53 17 18.639 15 19 15C19.517 15 20.517 15.667 22 17"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
